import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router';
import { opensAsPage, recordPage } from './open-in';
import { opensQuickViews } from './quick-view-pages';

// Which contact is open in the side sheet (TF-373): a contact opened over an account, a deal or the
// calendar, which stay where they were. In the address, ?contact=<id>, as a deal's quick view is
// (useDealQuickView), so a reload keeps it open and back closes it. A link to a contact opens it when
// the person chose "Side sheet" for contacts in My profile (TF-367, RecordLinkChoice in the shell).

const PARAM = 'contact';

export function useContactQuickView() {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { tenantId = '' } = useParams();
  const edit = (change: (params: URLSearchParams) => void) => (current: URLSearchParams) => {
    const next = new URLSearchParams(current);
    change(next);
    return next;
  };
  return {
    // Only over the pages it belongs on (TF-385): on the files page ?contact= is the list's filter.
    contactId: opensQuickViews(location.pathname) ? params.get(PARAM) : null,
    // As a page instead, when the person chose that in My profile (TF-367).
    open: (id: string) =>
      opensAsPage('contact') && tenantId ? navigate(recordPage(tenantId, 'contact', id)) : setParams(edit((next) => next.set(PARAM, id)), { state: { contactQuickView: true } }),
    close: () => {
      if ((location.state as { contactQuickView?: boolean } | null)?.contactQuickView) navigate(-1);
      else setParams(edit((next) => next.delete(PARAM)), { replace: true });
    },
  };
}
